import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpParamsEncoder } from '../tools/query-params-encoder';

@Injectable({ providedIn: 'root' })
export class ClinicService extends ApiService {
  endPoint = '/api/clinics';
  create(model: any) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: any) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<any> {
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<any> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }

  getClinicUsers(clinicId: string, queryParams: any): Observable<any> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/${clinicId}/users`, { params });
  }

  getPersonClinics(): Observable<any[]> {
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/person-clinics`);
  }
  getClinicBranches(): Observable<any[]> {
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/clinic-branches`);
  }

  addNewUser(id: string, tenantId: string, model: any) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/${id}/users/${tenantId}`, model);
  }

  changeLogo(id: string, imagePath: string){
      return this.http.put<any>(`${this.clinicsBaseURL}${this.endPoint}/changelogo/${id}`, {"base64String": imagePath});
  }
}
